/* ============================================================
   FantasyDice Phase 2 — Cinematic Motion Engine
   Duplicate theme only — NOT published
   ============================================================ */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------
     EMBER PARTICLE SYSTEM
     -------------------------------------------------------- */
  function initEmbers() {
    var hero = document.querySelector('.banner, .hero, [class*="slideshow"], .section-template--index');
    if (!hero) return;

    hero.style.position = 'relative';
    hero.style.overflow = 'hidden';

    var fog = document.createElement('div');
    fog.className = 'fd-fog';
    hero.insertBefore(fog, hero.firstChild);

    var vignette = document.createElement('div');
    vignette.className = 'fd-vignette';
    hero.insertBefore(vignette, hero.firstChild);

    var canvas = document.createElement('canvas');
    canvas.id = 'fd-ember-canvas';
    hero.insertBefore(canvas, hero.firstChild);

    var ctx = canvas.getContext('2d');
    var W, H, embers = [], raf = null;

    function resize() {
      W = canvas.width  = hero.offsetWidth;
      H = canvas.height = hero.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function mkEmber() {
      return {
        x: Math.random() * W,
        y: H + 8,
        r: Math.random() * 2.2 + 0.5,
        vy: Math.random() * 0.75 + 0.3,
        vx: (Math.random() - 0.5) * 0.35,
        life: 1,
        decay: Math.random() * 0.0025 + 0.001,
        hue: Math.random() > 0.65 ? 46 : 18
      };
    }

    for (var s = 0; s < 28; s++) {
      var e0 = mkEmber();
      e0.y = Math.random() * H;
      embers.push(e0);
    }

    function frame() {
      ctx.clearRect(0, 0, W, H);

      if (embers.length < 48 && Math.random() < 0.28) embers.push(mkEmber());

      embers = embers.filter(function (e) { return e.life > 0; });

      embers.forEach(function (e) {
        e.y  -= e.vy;
        e.x  += e.vx + Math.sin(e.y * 0.018) * 0.28;
        e.life -= e.decay;

        var a = Math.max(0, e.life * 0.65);
        ctx.save();
        ctx.globalAlpha = a;
        ctx.fillStyle   = 'hsl(' + e.hue + ',92%,68%)';
        ctx.shadowBlur  = 7;
        ctx.shadowColor = 'hsl(' + e.hue + ',100%,58%)';
        ctx.beginPath();
        ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });

      raf = requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (!raf) frame(); }
        else { cancelAnimationFrame(raf); raf = null; }
      });
    });
    io.observe(hero);
    frame();
  }

  /* --------------------------------------------------------
     PARALLAX HERO
     -------------------------------------------------------- */
  function initParallax() {
    var hero = document.querySelector('.banner, .hero, [class*="slideshow"]');
    if (!hero) return;
    var media = hero.querySelector('.banner__media, .hero__media, [class*="banner"] .media, [class*="slideshow"] .media');
    if (!media) return;

    media.style.willChange = 'transform';
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      requestAnimationFrame(function () {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          var p = -rect.top / hero.offsetHeight;
          media.style.transform = 'translateY(' + (p * 28) + '%)';
        }
        ticking = false;
      });
      ticking = true;
    });
  }

  /* --------------------------------------------------------
     HEADER GLASS SCROLL
     -------------------------------------------------------- */
  function initHeaderScroll() {
    var headerSection = document.querySelector('[id^="shopify-section-header"]');
    if (!headerSection) return;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      requestAnimationFrame(function () {
        headerSection.classList.toggle('fd-header-scrolled', window.scrollY > 55);
        ticking = false;
      });
      ticking = true;
    });
  }

  /* --------------------------------------------------------
     CARD 3D TILT (desktop only)
     -------------------------------------------------------- */
  function initCardTilt() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
      var card = wrapper.querySelector('.card');
      if (!card) return;

      wrapper.addEventListener('mousemove', function (e) {
        var rect = wrapper.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width  - 0.5;
        var y = (e.clientY - rect.top)  / rect.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 6) + 'deg) translateZ(5px)';
      });

      wrapper.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.55s cubic-bezier(0.16,1,0.3,1)';
        card.style.transform  = '';
        setTimeout(function () { card.style.transition = ''; }, 600);
      });
    });
  }

  /* --------------------------------------------------------
     SCROLL REVEAL
     -------------------------------------------------------- */
  function initReveal() {
    var sel = [
      '.card-wrapper',
      '.collection-list__item',
      '.featured-collection',
      '.shopify-section > div > h2',
      '.shopify-section > div > h3',
      '.product__info-wrapper'
    ].join(',');

    var els = Array.from(document.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('.banner') && !el.closest('.hero') && !el.closest('[class*="slideshow"]');
    });

    els.forEach(function (el) { el.classList.add('fd-reveal'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('fd-visible');
          observer.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --------------------------------------------------------
     BUTTON RIPPLE
     -------------------------------------------------------- */
  function initRipple() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn, .button, [class*="button--primary"], .product-form__submit');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      var sz   = Math.max(rect.width, rect.height) * 2;
      var rip  = document.createElement('span');
      rip.className = 'fd-ripple';
      rip.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;'
        + 'left:' + (e.clientX - rect.left - sz / 2) + 'px;'
        + 'top:'  + (e.clientY - rect.top  - sz / 2) + 'px';
      btn.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 700);
    });
  }

  /* --------------------------------------------------------
     ORNAMENTAL SVG DIVIDERS
     -------------------------------------------------------- */
  function injectDividers() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0) return;
      var div = document.createElement('div');
      div.className = 'fd-divider';
      div.setAttribute('aria-hidden', 'true');
      div.innerHTML = '<svg viewBox="0 0 1200 36" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">'
        + '<line x1="0" y1="18" x2="520" y2="18" stroke="rgba(212,175,55,0.14)" stroke-width="1"/>'
        + '<polygon points="536,10 548,18 536,26 524,18" fill="none" stroke="rgba(212,175,55,0.45)" stroke-width="1"/>'
        + '<text x="600" y="23" text-anchor="middle" font-size="13" fill="rgba(212,175,55,0.45)" font-family="Georgia,serif">❦</text>'
        + '<polygon points="664,10 676,18 664,26 652,18" fill="none" stroke="rgba(212,175,55,0.45)" stroke-width="1"/>'
        + '<line x1="680" y1="18" x2="1200" y2="18" stroke="rgba(212,175,55,0.14)" stroke-width="1"/>'
        + '</svg>';
      sec.insertAdjacentElement('beforebegin', div);
    });
  }

  /* --------------------------------------------------------
     INIT
     -------------------------------------------------------- */
  function init() {
    if (!prefersReduced) {
      initEmbers();
      initParallax();
    }
    initHeaderScroll();
    if (!prefersReduced) initCardTilt();
    initReveal();
    initRipple();
    injectDividers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
